import { z } from 'zod';
import { ProviderSourceKindSchema, ReportingPeriodSchema } from './client-trial.js';
export const AnalyticsQuerySchema = z.object({
    organizationId: z.string().uuid(),
    period: ReportingPeriodSchema.default('TODAY'),
}).strict();
const CountSchema = z.number().int().nonnegative();
const BranchPerformanceSchema = z.object({
    id: z.string().uuid(),
    label: z.string().min(1).max(200),
    customersCreated: CountSchema,
    leadsCreated: CountSchema,
    openTasks: CountSchema,
    overdueTasks: CountSchema,
}).strict();
const TeamWorkloadSchema = z.object({
    membershipId: z.string().uuid(),
    displayName: z.string().nullable(),
    role: z.enum(['OWNER', 'TENANT_ADMIN', 'BRANCH_MANAGER', 'MEMBER']),
    assignedLeads: CountSchema,
    openTasks: CountSchema,
    overdueTasks: CountSchema,
}).strict();
export const AnalyticsOverviewSchema = z.object({
    period: ReportingPeriodSchema,
    timezone: z.literal('Africa/Cairo'),
    asOf: z.string(),
    evidence: z.object({
        attribution: z.literal('OBSERVED_ASSOCIATION_NOT_CAUSAL'),
        campaignCoverage: z.literal('NO_PERSISTED_CAMPAIGN_REFERENCE'),
        orders: z.literal('FIRST_PARTY_EVENT_ONLY'),
    }).strict(),
    acquisition: z.object({
        sessions: CountSchema,
        identifiedSessions: CountSchema,
        sessionCustomersWithLead: CountSchema,
        sessionsWithCompletedOrder: CountSchema,
        crmLeadsCreated: CountSchema,
        wonLeads: CountSchema,
        lostLeads: CountSchema,
        bySource: z.array(z.object({ id: z.string().uuid(), label: z.string().min(1), count: CountSchema }).strict()).max(100),
        bySourceTruncated: z.boolean(),
        byChannel: z.array(z.object({ sourceKind: ProviderSourceKindSchema, conversations: CountSchema, inboundEvents: CountSchema }).strict()).max(6),
    }).strict(),
    branches: z.array(BranchPerformanceSchema).max(100),
    branchesTruncated: z.boolean(),
    team: z.array(TeamWorkloadSchema).max(500),
    teamTruncated: z.boolean(),
    corporate: z.object({
        companies: CountSchema, openOpportunities: CountSchema, wonOpportunities: CountSchema,
        lostOpportunities: CountSchema, openTasks: CountSchema, overdueTasks: CountSchema,
    }).strict(),
    insurance: z.object({
        providers: CountSchema, activeProviders: CountSchema, openFollowUps: CountSchema, overdueFollowUps: CountSchema,
    }).strict(),
    catalog: z.object({
        imports: CountSchema, approvedImports: CountSchema, importsNeedingReview: CountSchema,
        items: CountSchema, reconciliationItems: CountSchema,
    }).strict(),
    loyalty: z.object({
        accounts: CountSchema, pointsBalance: z.number().int(), ledgerEntries: CountSchema,
        earnedPoints: CountSchema, redeemedPoints: CountSchema,
    }).strict(),
    automation: z.object({
        rules: CountSchema, enabledRules: CountSchema, runs: CountSchema, succeededRuns: CountSchema,
        failedRuns: CountSchema, openAlerts: CountSchema,
    }).strict(),
    communications: z.object({ conversations: CountSchema, unhandled: CountSchema, inboundEvents: CountSchema }).strict(),
    providerIntake: z.object({
        websiteEvents: CountSchema, inboundEvents: CountSchema, latestReceivedAt: z.string().nullable(),
    }).strict(),
    journeys: z.object({
        sessions: CountSchema, identifiedSessions: CountSchema, firstPartyEvents: CountSchema,
        exactIdentityLinks: CountSchema, openIdentityConflicts: CountSchema,
    }).strict(),
}).strict();
export const AnalyticsOverviewResponseSchema = z.object({
    success: z.literal(true),
    data: AnalyticsOverviewSchema,
}).strict();
//# sourceMappingURL=analytics.js.map